<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Editar Produtor" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-producer
            v-if="!$loader.loading"
            :producer="producer"
            :readonly="false"
            @submit="($model: Producer) => submit($model)"
          />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormProducer from '@/views/producers/form-producer.vue'
import ProducerService from '@/services/ProducerService'
import type Producer from '@/types/Producer'

export default defineComponent({
  components: {
    TPageTitle,
    FormProducer,
  },
  data() {
    return {
      producer: {} as Producer,
    }
  },
  computed: {
    producerID() {
      return this.$route.params.id as string
    },
  },
  async created() {
    this.fetchProducer()
  },
  methods: {
    async fetchProducer() {
      try {
        this.$loader.increment()

        const response = (await (new ProducerService()).show(this.producerID)).data

        this.producer = response
      } catch {
        this.$snackbar.show('Não foi possível carregar os dados do produtor', 'error')
      } finally {
        this.$loader.decrement()
      }
    },
    async submit(model: Producer) {
      try {
        this.$loader.increment()

        await (new ProducerService()).update(this.producerID, model)

        this.$snackbar.show('Produtor atualizado com sucesso', 'success')
        this.$router.push({ name: 'manage-producer' })
      } catch (error) {
        this.$snackbar.show('Não foi possível atualizar o produtor', 'error')
        throw error
      } finally {
        this.$loader.decrement()
      }
    },
  },
})
</script>
